import { Helmet } from "react-helmet-async";
import logo from "../assets/img/logocare-2.png"
function SEO({ title, description, name, type }) {

	
	return (
		<Helmet>
			{/* Standard metadata tags */}
			<title>{title}</title>
			<meta name='description' content={description} />
			{/* End standard metadata tags */}
			{/* Facebook tags */}
			<meta property='og:type' content='website' />
			<meta property='og:title' content={title} />
			<meta property='og:description' content={description} />
			<meta
				property='og:url'
				content='https://www.synergycarefoundation.org/'
			/>
			<meta property='og:image' content={logo} />
			{/* End Facebook tags */}
			{/* Twitter tags */}
			<meta name='twitter:creator' content={name} />
			<meta name='twitter:card' content='website' />
			<meta name='twitter:title' content={title} />
			<meta name='twitter:description' content={description} />
			<meta name='' content='' />
			{/* End Twitter tags */}
		</Helmet>
	);
}
export default SEO